<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="related-card">
    <div class="rel-top">
      <ItemIcon :type="relCard.source.toLowerCase()" size="sm" :filled="true" />
      <div class="more-info-wrap">
        <div class="publish-date-wrap">
          <span>{{ $t('dates_from') + computedShowDate }}</span>
        </div>
        <ItemTimeIcon :types="relCard.frequency" />
        <ItemLocaIcon :types="relCard.territories" />
      </div>
    </div>
    <div class="rel-card-title">{{ relCard.title }}</div>
    <div v-if="noMarkdownDesc" class="rel-card-description">{{ noMarkdownDesc }}</div>
    <div class="rel-bot">
      <div v-if="relCard.publishDate" class="card-desc">
        <div class="icon-calendar" />
        {{ formattedPublishDate }}
      </div>
      <div v-if="relCard.docSource !== ''" class="card-desc card-origin">
        <span v-html="relCard.docSource.join(', ')" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ItemIcon from '../ItemIcon'
import ItemTimeIcon from '../ItemTimeIcon.vue'
import ItemLocaIcon from '../ItemLocaIcon.vue'
const removeMd = require('remove-markdown')

export default {
  name: 'RelatedCard',
  components: { ItemIcon, ItemTimeIcon, ItemLocaIcon },
  props: {
    relCard: {
      type: Object,
    },
  },
  computed: {
    noMarkdownDesc() {
      return removeMd(this.relCard.description)
    },
    formattedPublishDate() {
      return (
        (this.relCard.publishDate &&
          dayjs(this.relCard.publishDate.replace('Z', '')).format('DD/MM/YYYY')) ||
        ''
      )
    },
    computedShowDate() {
      return (
        (this.relCard.showDate && dayjs(this.relCard.showDate.replace('Z', '')).format('YYYY')) ||
        ''
      )
    },
  },
}
</script>

<style lang="stylus" scoped>
.related-card
  display: flex
  flex-direction: column
  height: 100%

  .rel-top
    margin-bottom: vw(20px)

  .rel-card-title
    m-font-size(18, 26)
    color: black
    font-weight: 600
    margin-bottom: vw(10px)

  .rel-card-description
    m-font-size(14, 22)
    color: $grey
    display: -webkit-box
    font-weight: 300
    margin-bottom: vw(20px)
    overflow: hidden
    -webkit-box-orient: vertical
    -webkit-line-clamp: 3

  .rel-bot
    display: flex
    margin-top: auto

    .card-desc
      m-font-size(12, 16)
      // align-items: center
      color: $grey
      display: flex

      .mobile &
        m-font-size(14, 20)

      &:not(:last-child)
        border-right: 1px solid $bcn-other-grey
        margin-right: vw(10px)
        padding-right: vw(10px)

      .icon-calendar
        m-icon("calendar", 16)
        margin-right: vw(5px)
        margin-top: -0.15em

  .rel-top
    align-items: center
    display: flex
    justify-content: space-between

    .more-info-wrap
      align-items: center
      display: flex

    .publish-date-wrap
      border: 1px solid $corporate_color_light
      border-radius: vw(20px)
      display: flex
      padding: vw(5px) vw(15px)
      width: fit-content

      span
        m-font-size(12, 16)
        color: $grey-dark
        font-weight: 400
</style>
